import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';

import absc from '../absc';

const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToAbsc = ({ classes, record }) => (
    <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/absc',
            search: stringify({
                page: 1,
                perPage: 25,
                sort: 'id',
                order: 'DESC',
                filter: JSON.stringify({ ssn: record.ssn }),
            }),
        }}
        className={classes.link}
    >
        <absc.icon className={classes.icon} />ABSC
    </Button>
);


export default withStyles(styles)(LinkToAbsc);